import styled, { spacing } from "@rentiohq/web-theme";

/**
 * A note is plain text and is rendered as plain text.
 *
 * It used to go through dangerouslySetInnerHTML to turn its newlines into
 * <br/>, which also handed anything a broker typed to the browser as markup:
 * a colleague opening the candidacy ran it in their own session. The editor
 * behind these notes is a multiline text field, never a rich text one, so
 * there was never any markup to render; pre-wrap keeps the line breaks and
 * shows a typed "3 < 5" as the broker wrote it.
 */
export const Wrapper = styled.div`
  margin: 0 -${spacing("tight")};
  padding: ${spacing("tight")};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  &:hover {
    background: ${props => props.theme.colors.neutral10};
  }
`;

/**
 * One note in a candidacy that carries several of them.
 *
 * Separated by a line rather than by cards: they are one running record of
 * what has been said about a person, and a stack of cards reads as a stack of
 * unrelated things.
 */
export const NoteItem = styled.div`
  padding: ${spacing("tight")} 0;
  & + & {
    border-top: 1px solid ${props => props.theme.colors.neutral20};
  }
`;

export const NoteItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: ${spacing("tight")};
`;

export const NoteItemActions = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${spacing("tight")};
  flex-shrink: 0;
`;
